import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"
import _imports_0 from '@/assets/images/burst-white.svg'


const _hoisted_1 = { id: "nav" }
const _hoisted_2 = {
  key: 1,
  id: "logo"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "pull-right" }
const _hoisted_6 = {
  key: 0,
  class: "flex align-items-center relative"
}

import { onMounted, ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import EditEventOverlayPanel from './components/EditEventOverlayPanel.vue';
import UserProfileHeader from './components/UserProfileHeader.vue';
import Impersonate from './components/Impersonate.vue';
import ImpersonateTenant from './components/ImpersonateTenant.vue';
import UniversalScreenersModal from './components/UniversalScreenersModal.vue';
import { useBeacon } from '@/composables/HelpScoutWidget';
import { can, usePersonTypes, useTenant } from '@/composables';
import { useAuthStore, useMessageCenterStore } from '@/store';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

const useAuth = useAuthStore();
const messageCenter = useMessageCenterStore();
const $tenant = useTenant();
const { screen } = storeToRefs(messageCenter);
const isSupportAdmin = computed<boolean>(() => usePersonTypes.isSupportAdmin());
const isSuperAdmin = computed<boolean>(() => usePersonTypes.isSuperAdmin());
const onAdminPage = ref(false);

onMounted(() => {
  useBeacon(useAuth.user);
  onAdminPage.value = window.location.pathname.includes('/admin');
});

const canAccessBackpack = computed(() => {
  if (usePersonTypes.isClinician()) return true;

  return (useAuth.isSwitchTenant && usePersonTypes.isSupportAdmin()) || usePersonTypes.isSuperAdmin();
});

const openMessageCenter = () => {
  screen.value = 'list-chats';
  messageCenter.visible = true;
};

const openBeacon = () => window.Beacon('toggle');

const backpackRedirect = async () => {
  await useAuth.setTmsBackpackCookie();
  window.location.href = process.env.VUE_APP_BACKPACK_URL as string;
};

const isMessageCenterEnabled = () => {
  return (
    $tenant.tenantSettingEnabled(TENANT_SETTINGS.MESSAGE_CENTER) &&
    !useAuth.isImpersonating &&
    can([PERMISSIONS.CHAT_INDEX])
  );
};

const showScreenersModal = ref(false);

const hasSSISColabUserId = computed(() => {
  return !!useAuth.user?.ssis_colab_user_id;
});

const canAccessUniversalScreeners = computed(() => {
  return usePersonTypes.isSchoolAdmin() && hasSSISColabUserId.value;
});

const openScreenersModal = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  showScreenersModal.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(ImpersonateTenant),
    _createElementVNode("div", _hoisted_1, [
      (!isSupportAdmin.value && !onAdminPage.value)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: "/"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { id: "logo" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "logo-image"
                })
              ], -1)
            ]))]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "logo-image"
            }, null, -1)
          ]))])),
      (onAdminPage.value && isSupportAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_RouterLink, { to: "/admin" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "Insight Admin Panel", -1)
              ]))]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/",
              type: "button",
              class: "mr-3"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("span", null, "eLuma Insight", -1)
              ]))]),
              _: 1
            }),
            (canAccessBackpack.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: "/",
                  class: "backpack-link mr-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (backpackRedirect()))
                    }, "Backpack")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (canAccessUniversalScreeners.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 1,
                  to: "/",
                  class: "universal-screeners-link mr-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", { onClick: openScreenersModal }, "Universal Screeners")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_5, [
        (isMessageCenterEnabled())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Icon, {
                name: "chat_bubble",
                class: "text-color-secondary mr-3 cursor-pointer",
                onClick: openMessageCenter
              }),
              (_unref(messageCenter).hasUnreadChats)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    name: "circle",
                    class: "absolute top-0 mx-2 -my-1 text-sm cursor-pointer unread-message-indicator",
                    onClick: openMessageCenter
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(useAuth).loggedIn && isSuperAdmin.value)
          ? (_openBlock(), _createBlock(EditEventOverlayPanel, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(useAuth).loggedIn)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 2,
              name: "help",
              class: "text-color-secondary mr-3 cursor-pointer",
              onClick: openBeacon
            }))
          : _createCommentVNode("", true),
        _createVNode(UserProfileHeader),
        _createVNode(Impersonate)
      ])
    ]),
    _createVNode(UniversalScreenersModal, {
      visible: showScreenersModal.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showScreenersModal).value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})